import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \Preno\Customers\Infrastructure\Http\CustomerSignUpController::getSignUp
* @see Preno/Customers/Infrastructure/Http/CustomerSignUpController.php:52
* @route '//app.prenohq.com/sign-up'
*/
export const getSignUp = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getSignUp.url(options),
    method: 'get',
})

getSignUp.definition = {
    methods: ["get","head"],
    url: '//app.prenohq.com/sign-up',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Preno\Customers\Infrastructure\Http\CustomerSignUpController::getSignUp
* @see Preno/Customers/Infrastructure/Http/CustomerSignUpController.php:52
* @route '//app.prenohq.com/sign-up'
*/
getSignUp.url = (options?: RouteQueryOptions) => {
    return getSignUp.definition.url + queryParams(options)
}

/**
* @see \Preno\Customers\Infrastructure\Http\CustomerSignUpController::getSignUp
* @see Preno/Customers/Infrastructure/Http/CustomerSignUpController.php:52
* @route '//app.prenohq.com/sign-up'
*/
getSignUp.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getSignUp.url(options),
    method: 'get',
})

/**
* @see \Preno\Customers\Infrastructure\Http\CustomerSignUpController::getSignUp
* @see Preno/Customers/Infrastructure/Http/CustomerSignUpController.php:52
* @route '//app.prenohq.com/sign-up'
*/
getSignUp.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: getSignUp.url(options),
    method: 'head',
})

/**
* @see \Preno\Customers\Infrastructure\Http\CustomerSignUpController::postSignUp
* @see Preno/Customers/Infrastructure/Http/CustomerSignUpController.php:127
* @route '//app.prenohq.com/sign-up'
*/
export const postSignUp = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: postSignUp.url(options),
    method: 'post',
})

postSignUp.definition = {
    methods: ["post"],
    url: '//app.prenohq.com/sign-up',
} satisfies RouteDefinition<["post"]>

/**
* @see \Preno\Customers\Infrastructure\Http\CustomerSignUpController::postSignUp
* @see Preno/Customers/Infrastructure/Http/CustomerSignUpController.php:127
* @route '//app.prenohq.com/sign-up'
*/
postSignUp.url = (options?: RouteQueryOptions) => {
    return postSignUp.definition.url + queryParams(options)
}

/**
* @see \Preno\Customers\Infrastructure\Http\CustomerSignUpController::postSignUp
* @see Preno/Customers/Infrastructure/Http/CustomerSignUpController.php:127
* @route '//app.prenohq.com/sign-up'
*/
postSignUp.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: postSignUp.url(options),
    method: 'post',
})

const CustomerSignUpController = { getSignUp, postSignUp }

export default CustomerSignUpController